angular.module("avant.customer_applications.directives").directive "sectionButton", [
  'scroll'
  '$state'
  '$stateParams'
  (scroll, $state, $stateParams) ->
    restrict: 'A'
    scope:
      sectionName: '@sectionButton'
      sectionButtonText: '@'
      sectionButtonShowHotkey: '@'
    templateUrl: "/customer_application_renderer/section_button.html"

    link: (scope, element, attrs) ->
      parentScope = scope.$parent

      scope.submit_section = ->
        parentScope.submitSection(scope.sectionName)
         
      scope.is_valid_section = ->
        parentScope.isSubmittableSection(scope.sectionName)
]
